"use client";
import { motion } from "framer-motion";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function ThreeDMarquee({ items = [], className = "", centerOffset = 0, scale = 1.2, tileHeight = 220 }) {
  const columns = 4;
  const total = items?.length || 0;
  const perCol = Math.ceil(total / columns) || 1;
  const chunks = Array.from({ length: columns }, (_, i) => items.slice(i * perCol, i * perCol + perCol));

  return (
    <div
      className={cn("relative mx-auto overflow-hidden rounded-none", className)}
      style={{
        height: "100vh",
        width: "100vw",
        marginLeft: "calc(50% - 50vw)",
        marginRight: "calc(50% - 50vw)",
      }}
    >
      <div className="flex w-full h-full items-center justify-center">
        <div className="relative [perspective:1500px]" style={{ width: "130vw", height: "100%" }}>
          <div className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full" style={{ top: `calc(50% + ${centerOffset}px)` }}>
            <div
              className="grid w-full h-full grid-cols-4 gap-0"
              style={{ transform: `scale(${scale}) rotateX(52deg) rotateZ(-32deg)`, transformOrigin: "center" }}
            >
              {chunks.map((subarray, colIndex) => (
                <motion.div
                  key={colIndex}
                  animate={{ y: colIndex % 2 === 0 ? 36 : -36 }}
                  transition={{ duration: colIndex % 2 === 0 ? 12 : 16, repeat: Infinity, repeatType: "reverse" }}
                  className="flex flex-col items-start gap-0"
                >
                  {subarray.map((node, idx) => (
                    <motion.div
                      key={idx}
                      whileHover={{ y: -10 }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                      className="relative z-40 w-full overflow-hidden rounded-none ring-0 border-0 shadow-none flex items-center"
                      style={{ background: "rgba(12,12,12,0.35)", margin: "-0.5px" }}
                    >
                      <div className="w-full h-full p-4 text-white" style={{ height: tileHeight }}>
                        {node}
                      </div>
                    </motion.div>
                  ))}
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
